module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAA4klEQVQ4T+3ToW4CQRSF4f8kPERFRQWvgKuoqEDUYZCgmwZZVd1KBA9QWVEUBoeprEAg+wh9AATJIUuAULgz20mQjNy5++2dO2dFzbL9CLwBPUnjXLlym7YHwHBbswK6OTCJ2e4An0cfy4IhtoU+gEbQeRI8wWqgnR2Cf7B/QklwjxVCIbjBbN8Cs8SM6tJTHbklab7DmsDzEdYGrgLpB/g6eL4EXiT95qJRdXoXYO+S+lG7F8xnndkEeAgGPZL0VHoB18B98KNPqxgUYXVJDTHbr4lwlnoL2ZtB35S+GdR/rwFaPmQs+XgT8AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/shang.png
// module id = +AZk
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37 111